module.exports = __webpack_public_path__ + "static/img/russianroulette_en.ae51a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/russianroulette_en.png
// module id = roS+
// module chunks = 1